import React from "react";

import ReactDOM from "react-dom/client";

import "@fontsource/inter";

import "./index.css";

import App from "./App";

import reportWebVitals from "./reportWebVitals";

import {
  ClinicProvider
} from "./context/ClinicContext";

const root = ReactDOM.createRoot(
  document.getElementById("root")
);

root.render(

  <React.StrictMode>

      <App />

  </React.StrictMode>
);

reportWebVitals();
